import { observer } from "mobx-react-lite";
import React from "react";

import {
  FontIcon,
  FontSizes,
  TextBadge,
  TextBadgeColor,
  TextBadgeSize,
  TooltipHost
} from "@bps/fluent-ui";
import { Permission } from "@libs/gateways/core/CoreGateway.dtos.ts";
import { ConditionHelper } from "@modules/booking/screens/booking-calendar/components/appointment-dialog/components/appointment-form/context/ConditionHelper.ts";
import { EpisodeOfCare } from "@stores/clinical/models/EpisodeOfCare.ts";
import { useStores } from "@stores/hooks/useStores.ts";

interface ClaimNumberBadgeProps {
  episodeOfCare: EpisodeOfCare;
}

export const ClaimNumberBadge: React.FC<ClaimNumberBadgeProps> = observer(
  ({ episodeOfCare }) => {
    const { core } = useStores();

    const claimBadgeText = ConditionHelper.getClaimBadgeText(episodeOfCare);

    const displayOnHoldClaimIcon =
      episodeOfCare.claim?.isOnHold &&
      core.hasPermissions(Permission.ClaimRead);

    if (displayOnHoldClaimIcon) {
      return (
        <TooltipHost content="On hold">
          <TextBadge
            badgeColor={TextBadgeColor.lightGrey}
            badgeSize={TextBadgeSize.medium}
            horizontal
            horizontalAlign="center"
            tokens={{ childrenGap: 5 }}
            styles={{ root: { flex: 1, width: 150 } }}
          >
            <FontIcon
              iconName="Clock"
              styles={{
                root: {
                  fontSize: FontSizes.size12
                }
              }}
            />
            <span>{claimBadgeText}</span>
          </TextBadge>
        </TooltipHost>
      );
    }

    return (
      <TextBadge
        badgeColor={TextBadgeColor.blue}
        badgeSize={TextBadgeSize.medium}
        styles={{ root: { flex: 1 } }}
      >
        <span>{claimBadgeText}</span>
      </TextBadge>
    );
  }
);
